import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/image_ba5bb0.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Định hướng trở thành một Kỹ sư Phần mềm xuất sắc, tôi tập trung vào việc phát triển các ứng dụng di động đa nền tảng tối ưu hiệu suất bằng <b className="purple">Flutter</b>.
              <br />
              <br />
              Tôi thành thạo
              <i>
                <b className="purple"> Dart, Java, Kotlin </b>
              </i>
              và có đam mê đặc biệt với việc áp dụng <b className="purple">Clean Architecture</b> để xây dựng các nền tảng mã nguồn (codebase) linh hoạt, dễ mở rộng.
              <br />
              <br />
              Mục tiêu nghề nghiệp của tôi là mang năng lực cốt lõi này đóng góp cho các dự án di động mang tính đột phá, đồng thời tiếp tục mài giũa kỹ năng kiến trúc phần mềm trong một môi trường kỹ thuật chuyên nghiệp.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
